module.exports = __webpack_public_path__ + "static/image/sustainability/img-happiness-2025@2x.ver2_0_2.jpg?d4e0ba3b";